/**
 * Created by dimah on 09/08/17.
 */
import { B2BUserDTO } from "./user-b2b";

export class B2BMasterUserDTO extends B2BUserDTO {

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.entity_type = "b2b-master";
    }

}